import { FunctionColor, BrandColor, ColorMode } from '@lux/core';
export const buttonColor = {
    primary: BrandColor.primary,
    dark: FunctionColor.function100,
    bright: FunctionColor.function0,
};
export const hoverColor = {
    primary: 'var(--button-color-hover)',
    dark: FunctionColor.function80,
    bright: FunctionColor.function20,
};
export const textHoverColor = {
    ...hoverColor,
};
export const activeColor = {
    primary: 'var(--button-color-active)',
    dark: { [ColorMode.LIGHT]: FunctionColor.function100, [ColorMode.DARK]: '#A3A3A3' },
    bright: { [ColorMode.LIGHT]: '#A3A3A3', [ColorMode.DARK]: FunctionColor.function100 },
};
export const disabledColor = {
    primary: FunctionColor.function20,
    dark: FunctionColor.function20,
    bright: FunctionColor.function80,
};
//# sourceMappingURL=constants.js.map